import { useQuery } from '@tanstack/react-query'
import { categoryApiService } from 'api/services'
import { IUseCategories } from 'api/types/category'
import { QUERY_KEY } from 'app/constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useCategories = (): IUseCategories => {
  const { i18n } = useTranslation()

  const { data, isFetching, isSuccess, isError } = useQuery({
    queryKey: [QUERY_KEY.categories, { language: i18n.language }],
    queryFn: () => categoryApiService.getCategories(),
    select: (data) => data.data,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    staleTime: 1000 * 60 * 60,
  })

  return useMemo(() => {
    return {
      data: data ?? [],
      isFetching,
      isSuccess,
      isError,
    }
  }, [data, isFetching, isSuccess, isError])
}
